import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";

const AdminLogin = ({ onSubmit, loading }) => {
  const [key, setKey] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(key.trim());
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 py-16"
      style={{
        background:
          "radial-gradient(1200px 600px at 50% -10%, #4a6276 0%, #354556 45%, #2b3a49 100%)",
      }}
    >
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-6">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white/10 border border-white/15 text-[#cfe7f8]">
            <ShieldCheck className="h-6 w-6" />
          </span>
        </div>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h1 className="ht-display text-2xl text-[#2c3e50] text-center">
            Admin Sign In
          </h1>
          <p className="mt-2 text-sm text-[#5a6b7d] text-center ht-body">
            Enter the admin key to view community signups.
          </p>
          <form onSubmit={handleSubmit} className="mt-6 space-y-3">
            <input
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="Admin key"
              className="ht-input w-full rounded-md border border-[#d6dde4] bg-white px-4 py-3 text-[15px] placeholder:text-[#9aa6b2]"
              autoFocus
              autoComplete="off"
            />
            <button
              type="submit"
              disabled={loading}
              className="ht-btn w-full rounded-md bg-[#b6dcf3] hover:bg-[#a4d1ee] text-[#2c3e50] font-semibold py-3 text-[15px] disabled:opacity-70"
            >
              {loading ? "Verifying..." : "Sign In"}
            </button>
          </form>
          <p className="mt-4 text-xs text-[#7e8a96] text-center">
            For your security, the key lives only in this browser tab and is
            cleared when you close it.
          </p>
          <Link
            to="/"
            className="mt-5 flex items-center justify-center gap-2 text-sm text-[#3d6486] hover:text-[#2c3e50] transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Back to site
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
